module.exports = __webpack_public_path__ + "img/okimi.b933bcad.png";